import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils'; // Assuma que você tem um utilitário 'cn' como o do Shadcn
import BgNoise from './img/bg-noise.gif';

// Definição das variantes de classe com cva
const overlayVariants = cva(
  'absolute inset-0 flex items-center justify-center flex-wrap bg-black/72', // Classes base
  {
    variants: {
      // Variantes para o efeito de ruído
      hasNoise: {
        true: 'relative' // Torna o elemento pai relativo para os pseudo-elementos
      }
    },
    defaultVariants: {
      hasNoise: false // Por padrão, não há ruído
    }
  }
);

// Componente para os pseudo-elementos de ruído
const NoiseEffect = ({ children }) => {
  return (
    <>
      {/* Equivalente a &:before */}
      <div className="bg-black/72 absolute inset-0 z-20" />
      {/* Equivalente a &:after */}
      <div
        className="absolute inset-0 z-10 bg-repeat" // Ajuste o caminho da imagem se necessário
        style={{ backgroundImage: `url('${BgNoise}')` }}
      />
      {children} {/* Renderiza os filhos por cima dos efeitos */}
    </>
  );
};

const LiveClassPlayerOverlay = React.forwardRef(({ className, hasNoise = false, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(overlayVariants({ hasNoise }), className)}
      {...props}
    >
      {/* Renderiza o efeito de ruído apenas se hasNoise for true */}
      {hasNoise ? <NoiseEffect>{children}</NoiseEffect> : children}
    </div>
  );
});
LiveClassPlayerOverlay.displayName = 'LiveClassPlayerOverlay';

const LiveClassPlayerOverlayInner = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('relative z-10 text-center', className)} // Aplica as classes Tailwind
      {...props}
    >
      {children} {/* Renderiza o conteúdo dentro */}
    </div>
  );
});
LiveClassPlayerOverlayInner.displayName = 'LiveClassPlayerOverlayInner';

const LiveClassPlayerOverlayTitle = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <h2 // Usamos um h2 semântico para o título
      ref={ref}
      // Tailwind para: color: var(--color-neutral-bright), font-weight: 700, font-size: 1.3em
      className={cn('text-[1.3em] font-bold text-neutral-bright', className)}
      {...props}
    >
      {children}
    </h2>
  );
});
LiveClassPlayerOverlayTitle.displayName = 'LiveClassPlayerOverlayTitle';

const LiveClassPlayerOverlayBody = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <p // Usamos um p semântico para o corpo de texto
      ref={ref}
      // Tailwind para: color: var(--color-neutral-bright), font-weight: 300, font-size: 1em, margin: 5px auto
      className={cn('mx-auto mt-[5px] text-base font-light text-neutral-bright', className)}
      {...props}
    >
      {children}
    </p>
  );
});
LiveClassPlayerOverlayBody.displayName = 'LiveClassPlayerOverlayBody';

export { LiveClassPlayerOverlay, LiveClassPlayerOverlayInner, LiveClassPlayerOverlayTitle, LiveClassPlayerOverlayBody };
